interface Route {
  link: string;
  name: string;
}

export default class RouterHelper {
  private path: string[] = [];

  private name: string[] = [];

  home() {
    return this.add({ link: '', name: 'Home' });
  }

  intro() {
    return this.add({ link: 'intro', name: 'Intro' });
  }

  reports() {
    return this.add({ link: 'reports', name: 'Reports' });
  }

  login() {
    return this.add({ link: 'login', name: 'Login' });
  }

  signup() {
    return this.add({ link: 'signup', name: 'Signup' });
  }

  expired() {
    return this.add({ link: 'expired', name: 'Expired' });
  }

  expiredSession() {
    return this.add({ link: 'session-expired', name: 'SessionExpired' });
  }

  parent() {
    return this.add({ link: 'parent', name: 'Parent' });
  }

  about() {
    return this.add({ link: 'about', name: 'About' });
  }

  libraries() {
    return this.add({ link: 'libraries', name: 'Libraries' });
  }

  parents() {
    return this.add({ link: 'parents', name: 'Parents' });
  }

  organization() {
    return this.add({ link: 'organization', name: 'Organization' });
  }

  terms() {
    return this.add({ link: 'terms', name: 'TermsAndConditions' });
  }

  contacts() {
    return this.add({ link: 'contacts', name: 'Contacts' });
  }

  policy() {
    return this.add({ link: 'policy', name: 'Policy' });
  }

  greeting() {
    return this.add({ link: 'greeting', name: 'Greeting' });
  }

  forgotPassword() {
    return this.add({ link: 'forgot', name: 'ForgotPassword' });
  }

  recoveryPassword() {
    return this.add({ link: 'recovery-password', name: 'ForgotPassword' });
  }

  verifyEmail() {
    return this.add({ link: 'verify-email', name: 'VerifyEmail' });
  }

  administration() {
    return this.add({ link: 'administration', name: 'Administration' });
  }

  userAccounts() {
    return this.add({ link: 'user-accounts', name: 'UserAccounts' });
  }

  sessionControl() {
    return this.add({ link: 'session-control', name: 'sessionControl' });
  }

  personalEducationPlan() {
    return this.add({ link: 'personal-education-plan', name: 'personalEducationPlan' });
  }

  productUpdatesStream() {
    return this.add({ link: 'product-updates-stream', name: 'productUpdatesStream(' });
  }

  downloadableMaterials() {
    return this.add({ link: 'downloadable-materials', name: 'downloadableMaterials' });
  }

  faq() {
    return this.add({ link: 'faq', name: 'FAQ' });
  }

  employees() {
    return this.add({ link: 'employees', name: 'Employees' });
  }

  subscribers() {
    return this.add({ link: 'subscribers', name: 'Subscribers' });
  }

  applications() {
    return this.add({ link: 'applications', name: 'Applications' });
  }

  bundles() {
    return this.add({ link: 'bundles', name: 'Bundles' });
  }

  elf() {
    return this.add({ link: 'websites', name: 'Websites' });
  }

  downloadable() {
    return this.add({ link: 'downloadable', name: 'Downloadable' });
  }

  marketplace() {
    return this.add({ link: 'marketplace', name: 'Marketplace' });
  }

  bundlePage() {
    return this.add({ link: 'marketplace', name: 'BundlePage' });
  }

  activityCatalog() {
    return this.add({ link: 'catalog', name: 'ActivityCatalog' });
  }

  activity() {
    return this.add({ link: 'activity', name: 'Activity' });
  }

  activities() {
    return this.add({ link: 'activities', name: 'Activities' });
  }

  accountSettings() {
    return this.add({ link: 'account-settings', name: 'AccountSettings' });
  }

  param(paramName: string) {
    return this.add({ link: `:${paramName}`, name: `:${paramName}` });
  }

  dynamicPath(pathName: string | number) {
    return this.add({ link: `${pathName}`, name: `param ${pathName}` });
  }

  add(route: Route) {
    const { name, link } = route;
    this.path.push(link);
    this.name.push(name);
    return this;
  }

  getRoute() {
    const { path } = this;
    this.path = [];
    this.name = [];
    return `/${path.filter(Boolean).join('/')}`;
  }

  getName() {
    const { name } = this;
    this.path = [];
    this.name = [];
    return name.join('|');
  }
}
